<template>
  <div class="mt-4" v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Evento</h3>
      </div>
      <div>
        <div class="vx-row mt-4">
          <!-- Data do Evento -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-input--label">Data Evento</label>
            <div class="inputData">
              <flat-pickr
                :config="configdateTimePickerDay"
                v-model="formDadosEventos.dataEvento"
                placeholder="DD/MM/AAAA"
                name="Data do Evento"
              />
            </div>
          </div>

          <!-- Hora do Evento -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-input--label">Hora Evento</label>
            <div class="inputData">
              <vs-input
                class="w-full"
                v-model="formDadosEventos.horaEvento"
                v-mask="'##:##'"
                maxlength="5"
                placeholder="HH:MM"
                name="Hora do Evento"
                @input="
                  validaHoraMinuto(formDadosEventos.horaEvento, 'horaEvento')
                "
              />
            </div>
          </div>

          <!-- Dia da Semana -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Dia da Semana"
              name="Dia da Semana"
              v-model="diaSemana"
              disabled="true"
            />
          </div>

          <!-- Data do Primeiro E-mail -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-input--label">Data do Primeiro E-mail</label>
            <div class="inputData">
              <flat-pickr
                :config="configdateTimePickerDay"
                v-model="formDadosEventos.primeiroEmail"
                placeholder="DD/MM/AAAA"
                name="Data do Primeiro E-mail"
              />
            </div>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import dateConversion from '../../../../../utils/dateConversion';
import notify from '../../../../../utils/notify';

export default {
  props: ['formData'],
  watch: {
    formData(value) {
      if (!value.dadosEventos) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - DADOS EVENTOS FORM');
        return;
      }

      this.formDadosEventos = Object.assign(
        this.formDadosEventos,
        value.dadosEventos,
      );

      if (this.formDadosEventos.horaEvento) {
        this.formDadosEventos.horaEvento = this.formDadosEventos.horaEvento
          .split(':')
          .filter((value, index) => index < 2)
          .join(':');
      }

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosEventos = this.formDadosEventos;
    },
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      showComponent: true,
      formDadosEventos: {
        dataEvento: null,
        horaEvento: null,
        primeiroEmail: null,
      },

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  computed: {
    diaSemana() {
      if (!this.formDadosEventos.dataEvento) {
        return '';
      }

      const diaSemana = [
        'Domingo',
        'Segunda-Feira',
        'Terça-Feira',
        'Quarta-Feira',
        'Quinta-Feira',
        'Sexta-feira',
        'Sábado',
      ];

      return diaSemana[
        new Date(
          dateConversion.convertDateToISO(this.formDadosEventos.dataEvento) +
            ' 00:00',
        ).getDay()
      ];
    },
  },
  methods: {
    validaHoraMinuto(newValue, campo) {
      if (newValue.length >= 5) {
        if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(newValue)) {
          notify.notifyFail(
            this.$vs,
            `Hora ${campo} inválida. Insira uma hora válida no formato HH:MM`,
          );
          this.formDadosEventos[campo] = '';
        }
      }
    },
  },
  mounted() {
    if (!this.formData.dadosEventos) {
      console.error('ERRO NO CONTRATO DO OBJETO - DADOS EVENTOS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosEventos = this.formDadosEventos;
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}

input.flatpickr-input {
  width: 100%;
}
</style>
